// removed by extract-text-webpack-plugin
module.exports = {"document":"_263-suCTCWngibKHHORqqv","image":"_1Tog5O1OptfJgUvuzN6lCb","content":"_3O1SJYRyGfhIV0pdKun2v3","links":"SBboOT9nb_qqvHG-0PB0O","title":"_1lhgf3AtIBindZ3PCX9-Ic","pdf":"_1cp1F39Hs8doVPFHMq7O2T"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DocumentBlock/DocumentBlock.module.scss
// module id = 750
// module chunks = 0